// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 321 ? "ShoppingCart/app" : chunkId) + "." + {"97":"543136a9","204":"caca9c54","222":"a6bf9423","285":"70ccbe3b","303":"9e7f30ba","321":"a1e7ef2b","530":"7bb1b078","884":"19113315","975":"6ac927e8"}[chunkId] + ".chunk.js";
};